import {
  applyInitialFieldsToFile,
  removeInitialFieldsFromFileName,
} from "@/state/transactions/CurrentTransactionEvents";
import { InitialFieldsAlignment } from "@type/core/dashboard/dashboard.types";
import InitialFieldsSection from "@components/core/subComponents/InitialFields/InitialFieldsSection";
import React from "react";

interface RightPanelInitialFieldsProps {
  index: number;
  isInitialFieldsActivated: boolean;
  initialFieldsY: number;
  initialFieldsAlignment: InitialFieldsAlignment;
  filename: string;
  pageNumber: number;
  numberOfFiles: number;
  setIsInitialFieldsActivated: (activated: boolean) => void;
}

const RightPanelInitialFields: React.FC<RightPanelInitialFieldsProps> = ({
  index,
  numberOfFiles,
  isInitialFieldsActivated,
  initialFieldsY,
  initialFieldsAlignment,
  filename,
  setIsInitialFieldsActivated,
}: RightPanelInitialFieldsProps) => {
  const handleInitialFieldsActivation = (activated: boolean) => {
    if (activated) {
      applyInitialFieldsToFile({
        fileName: filename,
        y: initialFieldsY,
        alignment: initialFieldsAlignment,
      });
    } else {
      removeInitialFieldsFromFileName(filename);
    }
    setIsInitialFieldsActivated(activated);
  };

  return (
    <div className="d-flex flex-column">
      <InitialFieldsSection
        rank={index}
        numberOfFiles={numberOfFiles}
        activated={isInitialFieldsActivated}
        setActivated={handleInitialFieldsActivation}
        alignment={initialFieldsAlignment}
        setAlignment={(alignment) => {
          applyInitialFieldsToFile({
            fileName: filename,
            y: initialFieldsY,
            alignment,
          });
        }}
      />
    </div>
  );
};

export default RightPanelInitialFields;
